<template>
	<div class="item_sidebar" :class="itemClass">
		<div class="inner_box with_select">
			<div class="title">{{ title }}</div>
			<v-select class="small"
			          :options="selectData.option"
			          v-model="currOrientation"
			          @input="updatedData($event)"
			          label="text"
			          :reduce="x=>x.id"
			          :searchable="false"
			          :clearable="false"
			          append-to-body/>
		</div>
	</div>
</template>

<script>

import {mapGetters} from "vuex";
import {getOrientation} from "@/modules/page-editor/src/utils/props";

export default {
	name: 'Orientation',
	props: ['title', 'value', 'options'],
	data: function () {
		return {
			orientation: {mobile:null,desktop:'row',tablet:null},

			selectData: {
				option: this.options,
				selected: this.value,
			},
		}
	},
	computed: {
		...mapGetters(['current_view']),
		itemClass() {
			return this.title.toLowerCase().split(' ').join('_');
		},
		currOrientation: {
			get(){
				return getOrientation(this.orientation, this.current_view)
			},
			set(key,value) {
				this.$set(this.orientation, this.current_view || 'desktop', value);
				return getOrientation(this.orientation, this.current_view)
			}
		}
	},
	methods: {
		updatedData(val){
			let view = this.current_view;
			if (view==="tablets") view="tablet"; // fixes this.

			if (typeof this.orientation !== 'object')
				this.$set(this, 'orientation', {mobile:null,desktop:'row',tablet:null})

			this.$set(this.orientation, view, val);
			this.$emit('updated', this.orientation);
		},
	},
	created() {
		if (typeof this.value !== 'object')
			this.$set(this, 'orientation', {mobile:null,desktop:'row',tablet:null})
		else {
			try {
				this.$set(this, 'orientation', JSON.parse(JSON.stringify(this.value)))
			} catch (e) {
				this.$set(this, 'orientation', {mobile:null,desktop:'row',tablet:null})
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.with_select {
	.v-select {
		width: 100%;
	}
}
//.app-page-editor .select2_item .select2-container--default .select2-selection--single {
//	height: 28px !important;
//	border: 1px solid #E4E6F1 !important;
//}
//
//.txt-style-group .select2-container {
//	min-width: 60px;
//}
//
//.txt-style-group .select2_item .select2-container .select2-selection--single .select2-selection__rendered {
//	padding: 0 10px !important;
//}
</style>
